import { render, staticRenderFns } from "./otaUserConf.vue?vue&type=template&id=61c0eb0d&scoped=true"
import script from "./otaUserConf.vue?vue&type=script&lang=js"
export * from "./otaUserConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0eb0d",
  null
  
)

export default component.exports